<template>
    <div id="folder_main" @click="select()">
        <i class="fas fa-folder fc-main"></i>
        <div id="folder_name" class="ff-varela fs-small">
            {{ data.name }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "folder",
        props: ['data'],
        data(){
            return{

            }
        },
        methods: {
            select(){
                this.$emit('select', this.data.name)
            }
        }
    }
</script>

<style scoped>
    #folder_main{
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
        align-items: center;
    }
    #folder_name{
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        width: 120px;
        height: 1.2em;
        white-space: nowrap;
        padding-top: 10px;
        margin: 0;
    }
    #folder_main>i{
        display: flex;
        height: 60%;
        width: 100%;
        justify-content: center;
        align-items: center;
        font-size: 60px;
        cursor: pointer;
    }
</style>
